import { EFieldTypes, IShemaMessage } from "@middleware/types";
import * as yup from "yup";

export const fields = [
  {
    type: EFieldTypes.EMAIL,
    name: "email",
    class: "input-text",
    placeholder: "form.emailExample",
    required: true,
    icon: "",
  },
];
export const defaultValues = {
  firstName: "M/Mme",
  email: "",
  phoneNumber: "",
  familyStatus: "liveAloneNoChildren", // TODO .... set default value for now
};

export const getSchema = (messages: IShemaMessage) => {
  return yup.object().shape({
    email: yup
      .string()
      .email(messages.invalidEmail)
      .required(messages.requiredField),
  });
};
